import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke="#344054"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.73 2.237c.62-.673.93-1.009 1.26-1.205a2.588 2.588 0 0 1 2.587-.039c.335.186.655.513 1.295 1.167.64.654.96.98 1.143 1.323.44.827.425 1.829-.038 2.642-.192.337-.522.654-1.18 1.289L7.96 14.96c-1.248 1.202-1.872 1.804-2.652 2.108-.78.305-1.637.282-3.352.238l-.234-.007c-.522-.013-.783-.02-.934-.192-.152-.172-.131-.438-.09-.97l.023-.289c.116-1.497.174-2.245.467-2.918.292-.672.796-1.219 1.804-2.311l7.737-8.383ZM9.836 2.332l5.833 5.833"
    />
    <path
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.668 17.332h6.667"
    />
  </svg>
)
export default SvgComponent
